<!--
 * @描述: 活动列表卡片
 * @作者: Puil.YU
 * @时间: 2021年04月08日
-->
<template>
<div class="a_position_r">
  <div>
      <div class="flex-center">
        <van-image
          style="margin-right: 12px"
          fit="cover"
          width="136"
          height="80"
          :src="item.bannerUrl"
          lazy-load
        />
        <div>
          <div class="title van-multi-ellipsis--l2">{{item.activityName}}</div>
          <div class="subtitle">
            <div >{{ moment(item.startTime).format('YYYY-MM-DD HH:mm')}} 至 {{ moment(item.enterLimitTime).format('YYYY-MM-DD HH:mm')}}</div>
            <div style="font-size: 11px">{{ item.activityType === 'OFFLINE' ? '同城活动' : '福利活动' }}</div>
          </div>
        </div>
      </div>
      <div
        class="flex-center"
        style="margin-top: 8px; justify-content: space-between"
      >
        <div class="flex a_flex_a" style="color: #969799;font-size: 13px;line-height: 22px;">
          <img
            style="width: 16px; height: 16px; margin-right: 10px;"
            src="https://aosnext-test-img.hotwater.com.cn/images/20210424/0075ef23fb524ca7a87e858adf1b6d6d.png"
          />
          已有 {{ item.enterNum || 0 }} 人报名参加
        </div>
        <van-button
          plain
          type="primary"
          round
          style="
            height: 32px;
            border: 1px solid #1f7dde;
            box-sizing: border-box;
            border-radius: 50px;
            color: #1f7dde;
            font-size: 13px;
          "
        >
          立即报名
        </van-button>
      </div>
  </div>
  <div class="a_position_a" style="width:100%;top:0px;z-index:11;height:100%">
     <LinkWeappBtn :url="`/pages/detail.html?id=${item.activityId}&shareId=${shareId}`" @launch="launch(item.activityId)">
       <script type="text/wxtag-template">
       <style>
         .style{
           width:343px;
           height:154px;
          }
          </style>
         <div class="style"></div>
       </script>
      </LinkWeappBtn>
  </div>

</div>
</template>

<script>
import moment from "moment";
import LinkWeappBtn from "@/components/LinkWeappBtn";
// import { mapState } from 'vuex'
export default {
  components: {
    LinkWeappBtn,
  },
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      },
    },
    shareId:{
      type: String,
      default: function() {
        return "";
      },
    }
  },
  data() {
    return {
      active: 0,
      isSHow: false,
      moment: moment,
      isLoading: false,
      error: false,
      colorMap: {
        审核中: "#EB5757",
        未通过: "#EB5757",
        审核失败: "#EB5757",
        进行中: "#52C41A",
        已结束: "#FAAD14",
        未开始: "#2F80ED",
      },
    };
  },
  methods: {
    launch(activityId){
        console.log(activityId)
        this.$store.dispatch('wxLogin/getLogSave', {targetId:activityId,shareId:this.shareId,targetType:"ACTIVITY"})
      },
  },
};
</script>

<style lang="less" scoped>
.navPosition {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 100;
}
.flow {
  text-align: left;
  word-break: keep-all;
  word-wrap: break-word;
}
.nopass {
  text-align: center;
  font-size: 18px;
  margin-top: 41px;
}
.banner {
  background: url("https://img.esenyun.com/images/20200302/2be97d11937a4744afa45eb23290fe2f.png")
    no-repeat;
  background-size: 100%;
}
.title{
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #323233;
}
.subtitle{
  font-size: 10px;
  line-height: 20px;
  color: #4A4A4A;
}
</style>
